<template>
  <div class="input-wrapper">
    <label
      :for="inputData.name"
      v-if="data.Text && useLabel"
      :title="data.Text"
      >{{ data.Text }}</label
    >
    <input
      :id="inputData.name"
      type="text"
      :placeholder="data.Text && !useLabel ? data.Text : false"
      class="input-ssn private"
      :value="valuePrivate"
      @focus="onFocusPrivate"
      v-if="valuePrivate && !isFocused"
    />
    <input
      :id="inputData.name"
      :name="data.Id"
      :required="inputData.required"
      type="text"
      :placeholder="data.Text && !useLabel ? data.Text : 'e.g. 555-55-5555'"
      ref="input-ssn"
      class="input-ssn"
      v-model="inputVal"
      @keydown="onKeyDown"
      @keypress="onType"
      @focus="onFocus"
      @blur="onBlur"
      maxlength="11"
      pattern="\d{3}-\d{2}-\d{4}"
      v-else
    />
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'InputSSN',
  components: {},
  props: {
    value: String,
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
    useLabel: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      isFocused: false,
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      }
    }
  },
  computed: {
    inputVal: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    },
    valuePrivate: function() {
      const currVal = this.inputVal.replace(/[^\d.]/g, '')
      if (currVal.length == 9) {
        const lastFour = currVal.substr(currVal.length - 4)
        return '***-**-' + lastFour
      }
      return ''
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal
      const parsedValue = PreApproveMe.parseInputValue(this.inputData)
      this.$emit('input:value-parsed', parsedValue)
      if (parsedValue !== false) {
        this.$emit('input:isvalid', true)
        this.$emit('input', parsedValue)
      } else {
        this.$emit('input:isvalid', false)
        if (alert && this.inputVal) {
          this.alert(this.data.Text + ' is invalid')
        }
      }
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    onKeyDown: function(evt) {
      const currValue = this.inputVal
      if (evt.key == 'Backspace') {
        const lastChar = currValue[currValue.length - 1]
        if (lastChar == '-') this.$emit('input', currValue.slice(0, -1))
      }
    },
    onType: function(evt) {
      const currValue = this.inputData.value
      const re = new RegExp('^[0-9]{1}$')
      const isNumber = re.test(evt.key)
      if (isNumber) {
        if (currValue.length == 3) this.$emit('input', currValue + '-')
        if (currValue.length == 6) this.$emit('input', currValue + '-')
      }
    },
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.validate()
      this.isFocused = false
      this.$emit('input:isfocused', false)
    },
    onFocusPrivate: function() {
      this.isFocused = true
      // This used to work before adding v-else to the real input
      // but now it seems to auto-focus without this
      // console.log(this.$refs)
      // this.$refs['input-ssn'].focus()
    }
  },
  created: function() {
    if (this.data.Type) this.inputData.type = this.data.Type
    else this.inputData.type = PreApproveMe.getInputType('Text')
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required
    // if (this.data.Value) {
    //   this.inputData.value = this.data.Value
    //   this.validate()
    // }

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
  },
  watch: {
    inputVal: function(value) {
      this.$emit('input:change', value)
      this.validate()
    }
  }
}
</script>

<style scoped lang="scss">
input.input-ssn {
}
</style>
